import { CanceledError } from 'axios';
import { useAuthStore } from '@/stores/useAuthStore';
import type { LocalSession, CredentialFlow } from './types';
import { useGuestStore } from '@/stores/useGuestStore';
import { usePreferenceStore } from '@/stores/usePreferenceStore';

export function currentLocalSession(): LocalSession | undefined {
  const state = useAuthStore.getState();
  return state.member && state.accessToken
    ? { actorId: state.member.id, epoch: state.sessionEpoch }
    : undefined;
}
export function isCurrentSession(binding: LocalSession | undefined) {
  const current = currentLocalSession();
  return (
    !!binding &&
    current?.actorId === binding.actorId &&
    current?.epoch === binding.epoch
  );
}
export function requireCurrentSession(binding: LocalSession) {
  if (!isCurrentSession(binding)) throw new CanceledError('SESSION_CHANGED');
}

/** Explicit credential forms can begin anonymously and must not merge a different guest. */
export function currentCredentialFlow(): CredentialFlow {
  return {
    authEpoch: useAuthStore.getState().sessionEpoch,
    guestEpoch: useGuestStore.getState().sessionEpoch,
    locale: usePreferenceStore.getState().locale ?? 'en',
  };
}
export function requireCurrentCredentialFlow(flow: CredentialFlow) {
  const current = currentCredentialFlow();
  if (
    current.authEpoch !== flow.authEpoch ||
    current.guestEpoch !== flow.guestEpoch ||
    current.locale !== flow.locale ||
    (flow.currency !== undefined &&
      flow.currency !== usePreferenceStore.getState().currency)
  )
    throw new CanceledError('SESSION_CHANGED');
}
